import { Component, OnInit, OnChanges ,Output, Input, ElementRef, HostListener, ViewEncapsulation, OnDestroy, HostBinding, ViewChild,ChangeDetectorRef,ChangeDetectionStrategy } from '@angular/core';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { VgAPI, VgFullscreenAPI, VgControlsHidden, VgStates } from 'videogular2/core';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'vg-like-component',
    
    templateUrl: './vg-like.template.html',
    styleUrls: ['./vg-like.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class VgLike {
    @Input() like:any;
   
    @Input() item:any;
    constructor(
        private interaction : EventInteraction,
        private ref : ChangeDetectorRef
    ){

    }

    ngOnDestroy(){

    }

    ngOnChanges( changes ) {
        if( changes.item ){
           this.like = changes.item.currentValue['liked'];
            this.ref.detectChanges();
        }
    }

    public onClick( e, toggle ){
       let push = false; 
       if ( toggle == this.like){
           this.like = null;   
       }else{
        this.like = toggle;   
       }
      
       this.interaction.next({key: "vg-like", message: this.like});
       this.ref.detectChanges();
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/video-player/controls/vg-like/vg-like.component.ts